const FAV_PULSE_MS = 720;

/** Pulso en el corazón del navbar (React en Navbar escucha favorites:pulse) */
export function pulseFavoriteNavIcon(mode = 'add') {
  window.dispatchEvent(new CustomEvent('favorites:pulse', { detail: { mode } }));
}

function spawnHeartParticles(fromEl) {
  if (!fromEl || typeof document === 'undefined') return;
  if (fromEl.id === 'np-fav-fly-target') return;

  const rect = fromEl.getBoundingClientRect();
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;

  for (let i = 0; i < 6; i += 1) {
    const p = document.createElement('span');
    p.className = 'np-fav-heart-particle';
    p.setAttribute('aria-hidden', 'true');
    p.innerHTML = '<i class="bi bi-heart-fill"></i>';
    p.style.left = `${cx}px`;
    p.style.top = `${cy}px`;
    p.style.setProperty('--dx', `${(Math.random() - 0.5) * 56}px`);
    p.style.setProperty('--dy', `${-24 - Math.random() * 48}px`);
    p.style.setProperty('--rot', `${(Math.random() - 0.5) * 40}deg`);
    p.style.animationDelay = `${i * 0.04}s`;
    document.body.appendChild(p);
    window.setTimeout(() => p.remove(), 900);
  }
}

/** Animación en el botón de corazón que se clickeó (no el del navbar) */
export function playFavoriteButtonFx(buttonEl, mode = 'add') {
  if (!buttonEl || buttonEl.id === 'np-fav-fly-target') return;

  buttonEl.classList.remove('np-fav-btn--add', 'np-fav-btn--remove');
  void buttonEl.offsetWidth;
  buttonEl.classList.add(mode === 'remove' ? 'np-fav-btn--remove' : 'np-fav-btn--add');

  const icon = buttonEl.querySelector('i');
  if (icon) {
    icon.classList.remove('np-fav-icon--pop', 'np-fav-icon--break');
    void icon.offsetWidth;
    if (mode === 'remove') {
      icon.className = 'bi bi-heartbreak-fill np-fav-icon--break';
    } else {
      icon.className = 'bi bi-heart-fill np-fav-icon--pop';
    }
  }

  if (mode === 'add') spawnHeartParticles(buttonEl);

  window.setTimeout(() => {
    buttonEl.classList.remove('np-fav-btn--add', 'np-fav-btn--remove');
    icon?.classList.remove('np-fav-icon--pop', 'np-fav-icon--break');
    window.dispatchEvent(new CustomEvent('favorites:icon-sync'));
  }, FAV_PULSE_MS);
}

/** add | remove — navbar + botón origen */
export function animateFavoriteToggle(mode, sourceEl = null) {
  pulseFavoriteNavIcon(mode);
  playFavoriteButtonFx(sourceEl, mode);
}

export function showFavoriteAddedToast(productName) {
  if (typeof document === 'undefined') return;
  document.querySelector('.np-fav-toast-success')?.remove();

  const el = document.createElement('div');
  el.className = 'np-fav-toast-success';
  el.setAttribute('role', 'status');
  el.innerHTML = '<i class="bi bi-heart-fill me-2" aria-hidden="true"></i><span></span>';
  const textSpan = el.querySelector('span');
  const name = String(productName || '').trim();
  if (textSpan) {
    textSpan.textContent = name ? `${name} guardado en favoritos` : 'Agregado a favoritos';
  }
  document.body.appendChild(el);
  window.setTimeout(() => {
    el.classList.add('np-fav-toast-success--out');
    window.setTimeout(() => el.remove(), 320);
  }, 2200);
}
